import React from 'react';

import { TextProps } from '@/components/TextComponent';
import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { hasOddsChanged } from '@/feature/betslip-sbk/utils/betslip-utils';

import { BetSlipOdds } from '../BetSlipOdds';

type SinglesOddsProps = {
    optionId: string;
} & TextProps;

export const SinglesOdds = ({ optionId, ...textProps }: SinglesOddsProps) => {
    const odds = useSbkBetSlipStore(state => state.options[optionId].odds);
    const previousOdds = useSbkBetSlipStore(state => state.oddsChanges[optionId]);

    return (
        <BetSlipOdds
            betId={optionId}
            odds={odds}
            previousOdds={previousOdds ?? null}
            hasOddsChanged={hasOddsChanged(odds, previousOdds)}
            {...textProps}
            testID="singlesOdds"
        />
    );
};
